import { defineMessages } from '@formatjs/intl';

const featuresRetentionScreen = defineMessages({
	featuresTitle: {
		id: 'profile.manageSubscription.cancellationFlow.features.title',
		defaultMessage: 'Wait, have you tried these features?',
		description: 'Title for Features retention screen',
	},
	featuresDescription: {
		id: 'profile.manageSubscription.cancellationFlow.features.description',
		defaultMessage: 'Check out a few of our recent updates before you go.',
		description: 'Description for Features retention screen',
	},
	quickMeditationTitle: {
		id: 'profile.manageSubscription.cancellationFlow.features.quickMeditation.title',
		defaultMessage: 'Build a more routine-friendly practice with Quick Meditations',
		description: 'Card title for Quick Meditations feature',
	},
	quickMeditationDescription: {
		id: 'profile.manageSubscription.cancellationFlow.features.quickMeditation.description',
		defaultMessage: 'A bunch of 2- to 5-minute meditations to bring calm to your busy days.',
		description: 'Card description for Quick Meditations feature',
	},
	sleepTitle: {
		id: 'profile.manageSubscription.cancellationFlow.features.sleep.title',
		defaultMessage: 'Fall asleep faster to more than 500 Sleep Stories',
		description: 'Card title for Sleep feature',
	},
	sleepDescription: {
		id: 'profile.manageSubscription.cancellationFlow.features.sleep.description',
		defaultMessage: 'The largest collection of audio bedtime stories for adults (and your kiddos too).',
		description: 'Card description for Sleep feature',
	},
	taptivitiesTitle: {
		id: 'profile.manageSubscription.cancellationFlow.features.taptivities.title',
		defaultMessage: 'Improve your mood in minutes with Taptivities',
		description: 'Card title for Taptivities feature',
	},
	taptivitiesDescription: {
		id: 'profile.manageSubscription.cancellationFlow.features.taptivities.description',
		defaultMessage: 'Interactive, text-based exercises to help you feel better, no meditation required.',
		description: 'Card description for Taptivities feature',
	},
});

const efficacyRetentionScreen = defineMessages({
	efficacyTitle: {
		id: 'profile.manageSubscription.cancellationFlow.efficacy.title',
		defaultMessage: "Life is stressful. Getting support shouldn't be.",
		description: 'Title for Efficacy retention screen',
	},
	efficacyDescription: {
		id: 'profile.manageSubscription.cancellationFlow.efficacy.description',
		defaultMessage: 'Try these pro tips to make Calm work for you.',
		description: 'Description for Efficacy retention screen',
	},
	tuneIntoYourselfTitle: {
		id: 'profile.manageSubscription.cancellationFlow.efficacy.tuneIntoYourself.title',
		defaultMessage: 'Tune into yourself for just 3 minutes each day',
		description: 'Card title for Tuning into yourself',
	},
	tuneIntoYourselfDescription: {
		id: 'profile.manageSubscription.cancellationFlow.efficacy.tuneIntoYourself.description',
		defaultMessage: 'Get started with our routine-friendly Quick Meditations and Taptivities.',
		description: 'Card description for Tuning into yourself',
	},
	trackProgressTitle: {
		id: 'profile.manageSubscription.cancellationFlow.efficacy.trackProgress.title',
		defaultMessage: 'Track your progress',
		description: 'Card title for Tracking your progress',
	},
	trackProgressDescription: {
		id: 'profile.manageSubscription.cancellationFlow.efficacy.trackProgress.description',
		defaultMessage:
			'Follow your weekly progress ring or start a new streak, then watch your confidence grow.',
		description: 'Card description for Tracking your progress',
	},
	notificationsTitle: {
		id: 'profile.manageSubscription.cancellationFlow.efficacy.notifications.title',
		defaultMessage: 'Turn on notifications on your phone',
		description: 'Card title for Turning on notifications',
	},
	notificationsDescription: {
		id: 'profile.manageSubscription.cancellationFlow.efficacy.notifications.description',
		defaultMessage: "We'll help you out with content recommendations and timely reminders.",
		description: 'Card description for Turning on notifications',
	},
});

const goalBasedContentRetentionScreen = defineMessages({
	goalBasedContentTitle: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.title',
		defaultMessage: '50,000 minutes of life-changing content at your fingertips.',
		description: 'Title for Goal-based Content retention screen',
	},
	goalBasedContentDescription: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.description',
		defaultMessage: 'Try one of our most-popular sessions.',
		description: 'Description for Goal-based Content retention screen',
	},
	sleepTab: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.sleepTab',
		defaultMessage: 'Sleep',
		description: 'Tab text for content related to Sleep',
	},
	sleepSlide1Title: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.sleepSlide1Title',
		defaultMessage: 'Crossing Ireland by Train',
		description: 'Title of Crossing Ireland by Train program',
	},
	sleepSlide1Narrator: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.sleepSlide1Narrator',
		defaultMessage: 'Cillian Murphy',
		description: 'Narrator of Crossing Ireland by Train',
	},
	sleepSlide2Title: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.sleepSlide2Title',
		defaultMessage: 'Wonder',
		description: 'Title of Wonder program',
	},
	sleepSlide2Narrator: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.sleepSlide2Narrator',
		defaultMessage: 'Matthew McConaughey',
		description: 'Narrator of Wonder',
	},
	sleepSlide3Title: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.sleepSlide3Title',
		defaultMessage: 'Dream with me',
		description: 'Title of Dream with me program',
	},
	sleepSlide3Narrator: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.sleepSlide3Narrator',
		defaultMessage: 'Harry Styles',
		description: 'Narrator of Dream with me',
	},
	sleepSlide4Title: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.sleepSlide4Title',
		defaultMessage: 'The Nordland Night Train',
		description: 'Title of The Nordland Night Train program',
	},
	sleepSlide4Narrator: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.sleepSlide4Narrator',
		defaultMessage: 'Erik Braa',
		description: 'Narrator of The Nordland Night Train',
	},
	sleepSlide5Title: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.sleepSlide5Title',
		defaultMessage: 'Journey to the Stars',
		description: 'Title of Journey to the Stars program',
	},
	sleepSlide5Narrator: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.sleepSlide5Narrator',
		defaultMessage: 'LeVar Burton',
		description: 'Narrator of Journey to the Stars Train',
	},
	stressTab: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.stressTab',
		defaultMessage: 'Stress & Anxiety',
		description: 'Tab text for content related to Stress & Anxiety',
	},
	stressSlide1Title: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.stressSlide1Title',
		defaultMessage: 'Calming Anxiety',
		description: 'Title of Calming Anxiety program',
	},
	stressSlide1Narrator: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.stressSlide1Narrator',
		defaultMessage: 'Tamara Levitt',
		description: 'Narrator of Calming Anxiety',
	},
	stressSlide2Title: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.stressSlide2Title',
		defaultMessage: '7 Days of Calm',
		description: 'Title of 7 Days of Calm program',
	},
	stressSlide2Narrator: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.stressSlide2Narrator',
		defaultMessage: 'Tamara Levitt',
		description: 'Narrator of 7 Days of Calm',
	},
	stressSlide3Title: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.stressSlide3Title',
		defaultMessage: 'Calm Island',
		description: 'Title of Calm Island program',
	},
	stressSlide4Title: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.stressSlide4Title',
		defaultMessage: 'Letting Go of Anxiety',
		description: 'Title of Letting Go of Anxiety program',
	},
	stressSlide4Narrator: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.stressSlide4Narrator',
		defaultMessage: 'Tamara Levitt',
		description: 'Narrator of Letting Go of Anxiety',
	},
	stressSlide5Title: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.stressSlide5Title',
		defaultMessage: 'Anxiety Release',
		description: 'Title of Anxiety Release program',
	},
	stressSlide5Narrator: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.stressSlide5Narrator',
		defaultMessage: 'Elisha Goldstein',
		description: 'Narrator of Anxiety Release',
	},
	focusTab: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.focusTab',
		defaultMessage: 'Focus',
		description: 'Tab text for content related to Focus',
	},
	focusSlide1Title: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.focusSlide1Title',
		defaultMessage: 'Infinite Lofi for Focus',
		description: 'Title of Infinite Lofi for Focus program',
	},
	focusSlide1Narrator: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.focusSlide1Narrator',
		defaultMessage: 'Curated by Calm',
		description: 'Narrator of Infinite Lofi for Focus',
	},
	focusSlide2Title: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.focusSlide2Title',
		defaultMessage: 'Silk: Music for Focus',
		description: 'Title of Silk: Music for Focus program',
	},
	focusSlide2Narrator: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.focusSlide2Narrator',
		defaultMessage: 'Bklava',
		description: 'Narrator of Silk: Music for Focus',
	},
	focusSlide3Title: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.focusSlide3Title',
		defaultMessage: 'Deep Focus',
		description: 'Title of Deep Focus program',
	},
	focusSlide3Narrator: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.focusSlide3Narrator',
		defaultMessage: 'our distant worlds',
		description: 'Narrator of Deep Focus',
	},
	focusSlide4Title: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.focusSlide4Title',
		defaultMessage: 'mau5trap: flow & focus',
		description: 'Title of mau5trap: flow & focus program',
	},
	focusSlide4Narrator: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.focusSlide4Narrator',
		defaultMessage: 'deadmau5 & friends',
		description: 'Narrator of mau5trap: flow & focus',
	},
	focusSlide5Title: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.focusSlide5Title',
		defaultMessage: 'Finding Focus',
		description: 'Title of Finding Focus program',
	},
	focusSlide5Narrator: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.focusSlide5Narrator',
		defaultMessage: 'Jeff Warren',
		description: 'Narrator of Finding Focus',
	},
	relaxationTab: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.relaxationTab',
		defaultMessage: 'Relaxation',
		description: 'Tab text for content related to Relaxation',
	},
	relaxationSlide1Title: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.relaxationSlide1Title',
		defaultMessage: 'Infinite Ambient for Relaxation',
		description: 'Title of Infinite Ambient for Relaxation program',
	},
	relaxationSlide1Narrator: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.relaxationSlide1Narrator',
		defaultMessage: 'Curated by Calm',
		description: 'Narrator of Infinite Ambient for Relaxation',
	},
	relaxationSlide2Title: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.relaxationSlide2Title',
		defaultMessage: 'Deep Sleep Relax',
		description: 'Title of Deep Sleep Relax program',
	},
	relaxationSlide2Narrator: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.relaxationSlide2Narrator',
		defaultMessage: 'Tamara Levitt',
		description: 'Narrator of Deep Sleep Relax',
	},
	relaxationSlide3Title: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.relaxationSlide3Title',
		defaultMessage: 'Midday Relaxation Break',
		description: 'Title of Midday Relaxation Break program',
	},
	relaxationSlide3Narrator: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.relaxationSlide3Narrator',
		defaultMessage: 'Curated by Calm',
		description: 'Narrator of Midday Relaxation Break',
	},
	relaxationSlide4Title: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.relaxationSlide4Title',
		defaultMessage: 'Breathe Into Relaxation',
		description: 'Title of Breathe Into Relaxation program',
	},
	relaxationSlide4Narrator: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.relaxationSlide4Narrator',
		defaultMessage: 'Jay Shetty',
		description: 'Narrator of Breathe Into Relaxation',
	},
	relaxationSlide5Title: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.relaxationSlide5Title',
		defaultMessage: 'Relaxing Harp for Stress Relief',
		description: 'Title of Relaxing Harp for Stress Relief program',
	},
	relaxationSlide5Narrator: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.relaxationSlide5Narrator',
		defaultMessage: 'Curated by Calm',
		description: 'Narrator of Relaxing Harp for Stress Relief',
	},
	physicalWellbeingTab: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.physicalWellbeingTab',
		defaultMessage: 'Physical Wellbeing',
		description: 'Tab text for content related to Physical Wellbeing',
	},
	physicalWellbeingSlide1Title: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.physicalWellbeingSlide1Title',
		defaultMessage: 'Jump Start Your Day',
		description: 'Title of Jump Start Your Day program',
	},
	physicalWellbeingSlide1Narrator: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.physicalWellbeingSlide1Narrator',
		defaultMessage: 'Mel Mah',
		description: 'Narrator of Jump Start Your Day',
	},
	physicalWellbeingSlide2Title: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.physicalWellbeingSlide2Title',
		defaultMessage: 'Releasing Physical Tension',
		description: 'Title of Releasing Physical Tension program',
	},
	physicalWellbeingSlide2Narrator: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.physicalWellbeingSlide2Narrator',
		defaultMessage: 'Mel Mah',
		description: 'Narrator of Releasing Physical Tension',
	},
	physicalWellbeingSlide3Title: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.physicalWellbeingSlide3Title',
		defaultMessage: 'Letting Go Of The Past',
		description: 'Title of Letting Go Of The Past program',
	},
	physicalWellbeingSlide3Narrator: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.physicalWellbeingSlide3Narrator',
		defaultMessage: 'Mel Mah',
		description: 'Narrator of Letting Go Of The Past',
	},
	physicalWellbeingSlide4Title: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.physicalWellbeingSlide4Title',
		defaultMessage: 'Meet Mel - Meet Your Body',
		description: 'Title of Meet Mel - Meet Your Body program',
	},
	physicalWellbeingSlide4Narrator: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.physicalWellbeingSlide4Narrator',
		defaultMessage: 'Mel Mah',
		description: 'Narrator of Meet Mel - Meet Your Body',
	},
	physicalWellbeingSlide5Title: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.physicalWellbeingSlide5Title',
		defaultMessage: 'Peace - An Inside Job',
		description: 'Title of Peace - An Inside Job program',
	},
	physicalWellbeingSlide5Narrator: {
		id: 'profile.manageSubscription.cancellationFlow.goalBasedContent.physicalWellbeingSlide5Narrator',
		defaultMessage: 'Mel Mah',
		description: 'Narrator of Peace - An Inside Job',
	},
});

const generic = defineMessages({
	keepSubscription: {
		id: 'profile.manageSubscription.cancellationFlow.keepSubscription',
		defaultMessage: 'Keep Subscription',
		description: 'CTA for user to keep their subscription and close the Cancellation Flow modal',
	},
	continueCancellation: {
		id: 'profile.manageSubscription.cancellationFlow.continueCancellationButton',
		defaultMessage: 'Continue Cancellation',
		description: 'Button text for users to continue with the cancellation flow',
	},
	backToCalm: {
		id: 'profile.manageSubscription.cancellationFlow.backToCalm',
		defaultMessage: 'Back to Calm',
		description: 'CTA text for returning to the main Calm interface',
	},
});

export default {
	...featuresRetentionScreen,
	...efficacyRetentionScreen,
	...goalBasedContentRetentionScreen,
	...generic,
};
